import strings from 'owa-strings/owa-options-strings';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
/**
 * Returns the string for the label of the checkbox fo the txp flag in the UI
 * @param flagName The name of the event flag
 */
export function getLabelForTxpFlag(flagName) {
    switch (flagName) {
        case 'FlightEventsFromEmailEnabled':
            return strings.options_txp_flights;
        case 'HotelEventsFromEmailEnabled':
            return strings.options_txp_hotelReservations;
        case 'RentalCarEventsFromEmailEnabled':
            return strings.options_txp_carRentals;
        case 'PackageDeliveryEventsFromEmailEnabled':
            return strings.options_txp_packageDelivery;
        case 'DiningEventsFromEmailEnabled':
            return strings.options_txp_diningReservations;
        case 'EntertainmentEventsFromEmailEnabled':
            return strings.options_txp_events;
        case 'InvoiceEventsFromEmailEnabled':
            return strings.options_txp_bills;
    }
}
/**
 * Checks the feature flags to determine if this event type is enabled
 * @param eventType The event type which should be validated
 */
export function isEventTypeEnabled(eventType) {
    switch (eventType) {
        case 'InvoiceEventsFromEmailEnabled':
            return isControlFeatureEnabled('cal-txp-invoice');
    }
    // All other events are enabled by default
    return true;
}
/**
 * Returns the list of all EventFlagTypes in the order they should be displayed in the UI
 */
export var EventsInOptionsPageInOrder = [
    'FlightEventsFromEmailEnabled',
    'HotelEventsFromEmailEnabled',
    'RentalCarEventsFromEmailEnabled',
    'PackageDeliveryEventsFromEmailEnabled',
    'DiningEventsFromEmailEnabled',
    'EntertainmentEventsFromEmailEnabled',
    'InvoiceEventsFromEmailEnabled',
];
//# sourceMappingURL=getTxpFlagInfo.js.map